import React from "react";

import { PaginationWithLimit } from "../../components/ui";
import { ContainerBg } from "../../useGeneralStyles";
import EvaluationJourneyTabs from "./components/EvaluationJourneyTabs";
import { useEvaluationsContext } from "../../context";

const Evaluations = (): React.ReactElement => {
  const { pagination } = useEvaluationsContext();
  const { count, limit, setLimit, setPage, page } = pagination;

  return (
    <ContainerBg>
      <EvaluationJourneyTabs />

      <div>
        <PaginationWithLimit
          count={count}
          limit={limit}
          page={page}
          setLimit={setLimit}
          setPageState={setPage}
        />
      </div>
    </ContainerBg>
  );
};

export default Evaluations;
